function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 52,
  r: 44,
  fill: "#FA6358",
  fillOpacity: 0.15
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M100.358 55.706c-3.188-3.53-7.711-6.009-12.456-6.76-2.521-4.206-6.377-7.435-10.9-9.012-2.001-.826-4.3-1.202-6.82-1.202-11.344 0-20.538 9.163-20.983 20.503C40.747 59.987 34 67.197 34 75.984c0 9.162 7.266 16.598 16.237 16.748h33.958c12.01 0 21.798-9.914 21.798-22.08.148-5.558-1.928-10.89-5.635-14.947zM84.343 88.6h-33.66c-6.896 0-12.531-5.708-12.531-12.692 0-6.985 5.635-12.693 12.53-12.693h2.67V59.91c0-9.463 7.562-17.123 16.904-17.123 2.002 0 3.781.3 5.412.976 3.93 1.427 7.192 4.28 9.194 8.036l.519.976 1.038.15a17.474 17.474 0 0110.973 5.558 18.072 18.072 0 014.671 12.167c0 9.839-7.933 17.95-17.72 17.95z",
  fill: "#444"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M80.487 60.59L66.919 73.81l-4.375-4.506a1.997 1.997 0 00-2.891 0 2.059 2.059 0 000 2.929l5.264 5.407c.519.526 1.26.826 2.002.826.741 0 1.483-.3 2.002-.826l14.457-14.12a2.13 2.13 0 00.075-2.928 2.084 2.084 0 00-2.966 0z",
  fill: "#444"
});

function SvgCloudinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 106 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default SvgCloudinline;